import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";

import apiClient from "../../utils/apiClient";

import TableComponent from "./TableComponent";
import LoadingSpinner from "../../components/loading-spinner";
import server from "../../utils/serverConfig";

export default function StrategyFirstTable() {
  const [liveOrders, setLiveOrders] = useState();

  const fetchLiveOrders = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}live_orders_data`,
    };

    apiClient
      .request(config)
      .then((response) => {
        setLiveOrders(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [accountName, setAccountName] = useState();

  const getAllAccountUser = () => {
    let config = {
      method: "get",
      url: "/api/fyers-user-token",
      headers: {
        "Content-Type": "application/json",
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        setAccountName(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchLiveOrders();
    getAllAccountUser();

    const intervalId = setInterval(fetchLiveOrders, 3600000);
    return () => clearInterval(intervalId);
  }, []);

  const fnoLiveTrades =
    liveOrders &&
    liveOrders.filter((symbol) => {
      const lastTwoCharacters = symbol.symbol.slice(-2);
      return lastTwoCharacters === "PE" || lastTwoCharacters === "CE";
    });

  const strategies =
    fnoLiveTrades &&
    fnoLiveTrades.reduce((acc, item) => {
      acc.push(item.strategy);
      return acc;
    }, []);

  const uniqueValuesSet = new Set(strategies);
  const uniqueValuesStrategies = [...uniqueValuesSet];

  const [updating, setUpdating] = useState(false);

  const updateData = () => {
    setUpdating(true);
    const url = `${server.godseye.baseUrl}update-orders`;
    const data = {
      secret_key: "cmdev500",
    };

    apiClient
      .post(url, data)
      .then((response) => {
        setUpdating(false);

        if (response.data.message === "updated") {
          fetchLiveOrders();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full min-h-screen">
        <div className="flex flex-row justify-between mt-8 items-center">
          <div className="text-xl text-white px-12">
            SS Strategy First Table
          </div>
          <button
            onClick={updateData}
            className="text-white flex items-center space-x-2 bg-gray-800/40 px-6 py-2 rounded-md mr-12"
          >
            {updating === true ? <LoadingSpinner /> : "Update Data"}
          </button>
        </div>

        <div className="flex flex-row border border-[#ffffff]/20 border-b-0 mt-6 ">
          <div className="w-[8.25%]"></div>
          <div className="w-[10.4%] border-l border-[#ffffff]/20"></div>
          <div className="w-[33.85%] text-white border-l border-[#ffffff]/20 text-center py-2">
            {" "}
            Strike Selection
          </div>
          <div className="w-[40%] text-white border-l border-[#ffffff]/20 text-center py-2">
            {" "}
            Strategy
          </div>
        </div>
        {fnoLiveTrades ? (
          <div className="flex flex-col flex-1 ">
            <TableComponent
              data={fnoLiveTrades && fnoLiveTrades}
              strategies={uniqueValuesStrategies && uniqueValuesStrategies}
              accountName={accountName}
            />
          </div>
        ) : (
          <div className="flex flex-row justify-center py-32">
            <LoadingSpinner />
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
